import React from "react";
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
import Button from "../../atoms/button/button";
import "./buttonAuth.scss";
import GlobalContext from "../../../contexts/globalContext";

const ButtonAuth = (props: ReferenciaContenido) => {

   const { tituloBoton, redireccionBoton, validarAutenticacion } = props;

   return (
      <GlobalContext.Consumer>
         { data =>( 
            <div className="m-btn-auth">
               { validarAutenticacion && data.gigyaContext.gigyaAccount ? (
                  <Button
                     type="link"
                     text= {tituloBoton}
                     classname="secondary"
                     href= { redireccionBoton }
                     target="_blank"
                     isDisabled={false}
                  />
               ):(
                  <Button
                     type="button"
                     text= {tituloBoton}
                     classname="secondary"
                     onClickAction={ data.gigyaContext.login }
                     target="_blank"
                     isDisabled={false}
                  />
               )
               }
            </div>
         )}
      </GlobalContext.Consumer>
   );
};

export default ButtonAuth;
